import * as types from "../actions/empTypes";


  const initialState = {
    data: [],
    loading: false,
    error: null,
  };
  
  const empReducer = (state = initialState, action, updatedEmployee) => {
    switch (action.type) {
      case types.UPDATE_EMPLOYEE_REQUEST:
        return {
          ...state,
          loading: true,
          payload: updatedEmployee,         
        };


      case types.UPDATE_EMPLOYEE_SUCCESS:
        ////console.log("Before state update", state); 
        ////console.log("updated employee" , action.payload);
        return {
          ...state,
          loading: false,
          data: state.data.map((item) =>
            item.id === action.payload.id ? action.payload : item
          ),
        };


        //FOR FETCHing employees
        case types.FETCH_EMPLOYEE_REQUEST:
            ////console.log(action.payload)
            return { 
                ...state,
                loading: true,
                payload: action.payload 
            };

        case types.FETCH_EMPLOYEE_SUCCESS:
            return { 
                ...state, 
                loading: false,
                data: action.payload 
            };


            //FOR DELETING EMPLOYEE

            case types.DELETE_EMPLOYEE_REQUEST:
                ////console.log(action.payload)
                return { 
                    ...state,
                    loading: true,
                    // payload: action.payload 
                };

            case types.DELETE_EMPLOYEE_SUCCESS:
              ////console.log("reducer delete employee", action.payload)
                ////console.log(action.payload);
                return {
                  ...state,
                  loading: false,
                  data: state.data.filter((item) => item.id !== action.payload),
                };

      case types.UPDATE_EMPLOYEE_FAILURE:
      case types.FETCH_EMPLOYEE_FAILURE:
      case types.DELETE_EMPLOYEE_FAILURE:
    
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default empReducer;
  